import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import { useAuth } from "../../contexts/AuthContext";
import { fetchWrapperNoAuth, fetchWrapperShipments, SERVER } from "../../utils/helpers";
import { Box } from "@mui/material";
import ShipmentsProductsTable from "../../components/Tables/ShipmentsProductsTable";
import ShipmentSuccessModal from "../../components/Modals/ShipmentSuccessModal";

function Shipment(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const { inboundOrderId, showSuccessPopup, successfulShipments } = location.state || {};
  const { theme } = useTheme();
  const { encodedAuth, user, password } = useAuth();

  const [shipments, setShipments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const getAllShipments = async () => {
    setIsLoading(true);
    let offset = 0;
    const LIMIT = 50;
    let totalCount = 0;
    let tempShipments = [];
    while (offset <= totalCount) {
      let body = {
        offset: offset,
        limit: LIMIT
      }

      try {
        const response = await fetchWrapperShipments(`${SERVER}/get_shipments`, user, password, encodedAuth, { body: body });
        totalCount = response.headers.totalCount;
        tempShipments = [...tempShipments, ...response.payload];
      } catch (error) {
        console.error(`All Shipments request failed:`, error.message);
      }

      offset += LIMIT;
    }
    // let inboundOrderIds = [];
    // try {
    //   const response = await fetchWrapperNoAuth(`${SERVER}/falcon_get_metadata/${user}`, user, password);
    //   inboundOrderIds = response.map(record => record.inbound_order_id).filter(io => io !== "");
    // } catch (error) {
    //   console.error(`All Shipments request failed:`, error.message);
    // }

    // tempShipments = tempShipments.filter(shipment => inboundOrderIds.includes(shipment.inboundOrderId))

    setShipments(tempShipments);
    setIsLoading(false);
  };

  const getSingleShipment = async (ioid) => {
    setIsLoading(true);
    let body = {
      inboundOrderId: ioid
    }

    try {
      const response = await fetchWrapperShipments(`${SERVER}/get_shipments`, user, password, encodedAuth, { body: body });
      setShipments(response.payload);
    } catch (error) {
      console.error(`Single Shipment request failed:`, error.message);
    }
    setIsLoading(false);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };

  const handleShowSellerCenter = (inboundOrderId) => {
    setShowPopup(false);
    setPopupData(null);
    window.open(`https://seller.walmart.com/wfs/shipments/order-details/${inboundOrderId}`)
  }

  useEffect(() => {
    if (showSuccessPopup) {
      setPopupData({
        successfulShipments: successfulShipments,
        inboundOrderId: inboundOrderId
      });
      setShowPopup(true);

      getSingleShipment(inboundOrderId);

      navigate(location.pathname, { replace: true });
    } else {
      getAllShipments();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Inventory Falcon</title>
        <meta
          name="description"
          content="The best inventory management software for Walmart sellers is coming soon! To join our beta program, please email us at: team@inventoryfalcon.com"
        />
      </Helmet>
      <Box sx={{ bgcolor: theme.background.primary, height: '-webkit-fill-available', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", mx: '10px', }}>
          <h1
            style={{
              fontSize: props.isMobile ? "3vh" : "2vw",
              fontWeight: "380",
              textAlign: "center",
              color: theme.text.primary,
            }}
          >
            Shipments
          </h1>
        </Box>
        <ShipmentsProductsTable shipments={shipments} setShipments={setShipments} isLoading={isLoading} />
      </Box>
      {popupData && (
        <ShipmentSuccessModal
          open={showPopup}
          onClose={handleClosePopup}
          successfulShipments={popupData.successfulShipments}
          inboundOrderId={popupData.inboundOrderId}
          onOpenSellerCenter={handleShowSellerCenter}
          isMobile={props.isMobile}
        />
      )}
    </>
  );
}
export default Shipment;
